window.addEventListener('load', function () {

  // offsetTopを取得しエフェクトを起こさせるobject
  const OBJECTS = Array.from(document.querySelectorAll('.js-scroll-effect'));

  // エフェクトクラスを付与する対象のobject
  const TARGETS = Array.from(document.querySelectorAll('.js-scroll-target'));

  // 上部固定要素があれば指定する
  const fixedContent = document.querySelector('.mod-fixednav.m-upper');

  let fixedContentHeight = 0;

  if(typeof(fixedContent) === true){
    fixedContentHeight = fixedContent.clientHeight - 10;
  }

  if(OBJECTS){
    let objects_top = OBJECTS.map(object => object.offsetTop - fixedContentHeight);
    let objects_class = OBJECTS.map(object => object.dataset.effectclass);

    window.addEventListener('scroll', function() {
      const y = window.scrollY;

      for (let i = 0; i < OBJECTS.length; i++) {
        if (y > objects_top[i]){
          TARGETS.forEach(target => target.classList.add(objects_class[i]));
        } else {
          TARGETS.forEach(target => target.classList.remove(objects_class[i]));
        }
      }

    });
  }

});

